import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class PacksService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getPacks(): Observable<any> {
    const url = `${this.BASE_URL}/pack/all`;
    return this.http.get<any>(url);
  }


}